/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Import_CancelInputs */

const en_preset_manager_import_cancel = /** @type {(inputs: Preset_Manager_Import_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_preset_manager_import_cancel = /** @type {(inputs: Preset_Manager_Import_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_preset_manager_import_cancel = /** @type {(inputs: Preset_Manager_Import_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornieren`)
};

const it_preset_manager_import_cancel = /** @type {(inputs: Preset_Manager_Import_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare`)
};

const ru_preset_manager_import_cancel = /** @type {(inputs: Preset_Manager_Import_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_preset_manager_import_cancel = /** @type {(inputs: Preset_Manager_Import_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const zh_cn2_preset_manager_import_cancel = /** @type {(inputs: Preset_Manager_Import_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_preset_manager_import_cancel = /** @type {(inputs: Preset_Manager_Import_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_preset_manager_import_cancel = /** @type {(inputs: Preset_Manager_Import_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const pt_pt2_preset_manager_import_cancel = /** @type {(inputs: Preset_Manager_Import_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Preset_Manager_Import_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_cancel = /** @type {((inputs?: Preset_Manager_Import_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_import_cancel(inputs)
	if (locale === "de") return de_preset_manager_import_cancel(inputs)
	if (locale === "it") return it_preset_manager_import_cancel(inputs)
	if (locale === "ru") return ru_preset_manager_import_cancel(inputs)
	if (locale === "es") return es_preset_manager_import_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_import_cancel(inputs)
	if (locale === "ja") return ja_preset_manager_import_cancel(inputs)
	if (locale === "hi") return hi_preset_manager_import_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_import_cancel(inputs)
	return en_preset_manager_import_cancel(inputs)
});